/** @format */
import React from 'react';
import MapComponent from './Map';
import LoadingBackdrop from './LoadingBackdrop';
import { useSmartServerConfig } from '../../hooks/useSmartServerConfig';

const MapWithConfig = () => {
  const { config, loading, error, environment } = useSmartServerConfig();

  if (loading) {
    return <LoadingBackdrop open={true} />;
  }

  if (error || !config) {
    return (
      <div className="config-error-container" style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#312f38',
        color: '#f0f0f0',
        textAlign: 'center',
        padding: '20px'
      }}>
        <div>
          <h2>⚠️ Configuration Error</h2>
          <p>Failed to load application configuration.</p>
          <p><strong>Environment:</strong> {environment}</p>
          {error && (
            <details style={{ marginTop: '10px', textAlign: 'left' }}>
              <summary>Error Details</summary>
              <pre style={{ 
                backgroundColor: '#44414d', 
                padding: '10px', 
                borderRadius: '4px',
                marginTop: '10px',
                fontSize: '12px'
              }}>
                {error.message}
              </pre>
            </details>
          )}
          <button 
            onClick={() => window.location.reload()}
            style={{
              marginTop: '20px',
              padding: '10px 20px',
              backgroundColor: '#615d6f',
              color: '#f0f0f0',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  // Pass config to the map component
  return <MapComponent config={config} environment={environment} />;
};

export default MapWithConfig;
